import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledWrapperWhatCanBeDone = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-top: 15px;

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 10px;
        @media ${breakpoints.sm} {
            flex: 3 33%;
            margin: 0 32px;
        }
        @media ${breakpoints.xs} {
            flex: 3 50%;
            margin: 5px 32px;
        }

        .item-image {
            display: flex;
            align-items: center;
            justify-content: center;

            .img {
                height: 115px;
                margin-bottom: 20px;
                @media ${breakpoints.sm} {
                    width: 110px;
                }
            }
        }

        .item-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .item-title {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 217px;
            height: 50px;
            font-size: var(--size-18);
            font-style: normal;
            font-weight: bold;
            line-height: 25px;
            color: var(--color-secondary);
            text-align: center;
            text-transform: uppercase;
            @media ${breakpoints.sm} {
                font-size: var(--size-14);
            }
        }

        .item-message {
            width: 192px;
            margin-top: 18px;
            font-size: var(--size-16);
            font-style: normal;
            font-weight: normal;
            line-height: 20px;
            color: var(--color-grey-900);
            text-align: center;
            @media ${breakpoints.sm} {
                margin-top: 16px;
                font-size: var(--size-14);
            }
        }
    }
`;
